module.exports = global["$"] = require("-!/home/runner/work/plugin-ceres/plugin-ceres/node_modules/expose-loader/index.js?jQuery!./jquery.js");